import request from '@/utils/request'

export function getmbuildgp(blgscd) {
  return request({
    url: `/api/mbuildgpList/sections/${blgscd}`,
    method: 'get',
  })
}

// export function getmbuildgp(blgscd) {
//   return request({
//     url: `/api/mbuildgpList/sections`,
//     method: 'get',
//     params: { blgscd: blgscd },
//   })
// }
